import reduceReducers from 'reduce-reducers';

import {
    createFetchReducer, FetchSuccessAction, isFetchSuccessAction
} from '../middleware';
import { UserProfilesState } from './user-profiles.types';
import { groupModulesById } from './utils';
import { groupById } from '@utils';

export const USER_PROFILES_STATE_NAME = 'userProfiles';

export const EMAIL_STATUS_NAME = 'emailStatus';

export const INITIAL_USER_PROFILES_STATE: UserProfilesState = {
    data: null,
    groups: null,
    modules: null,
    isLoading: false,
    isError: false,
    isSuccess: false,
    error: null
};

export function userProfilesSliceReducer (
    state: UserProfilesState = INITIAL_USER_PROFILES_STATE,
    action: FetchSuccessAction
): UserProfilesState {
    if (isFetchSuccessAction(USER_PROFILES_STATE_NAME, action)) {
        return {
            ...state,
            modules: groupById(action.payload.data.modules),
            groups: groupModulesById(action.payload.data.modules)
        };
    }

    return state;
}

export const getUserProfilesReducer = () => {
    const userProfilesFetchReducer = createFetchReducer(
        USER_PROFILES_STATE_NAME,
        INITIAL_USER_PROFILES_STATE
    );

    // Combine the abstracted fetch with an additional reducer to add to the state
    // as per: https://redux.js.org/usage/structuring-reducers/beyond-combinereducers
    return reduceReducers(
        userProfilesFetchReducer,
        userProfilesSliceReducer
    );
};
